module.exports = __webpack_public_path__ + "a769ade6cc7470874d7891a657f4ca58.svg";